const combinationVehicles = [
  // ── COMBINATION VEHICLE BASICS ─────────────────────────────────────────────
  {
    id: "cv001",
    question: "A combination vehicle consists of:",
    options: [
      "A tractor only",
      "A power unit (tractor) connected to one or more trailers",
      "Any vehicle with more than two axles",
      "A straight truck with a trailer hitch",
    ],
    answer: 1,
    explanation: "A combination vehicle is a tractor (power unit) connected to one or more trailers. Class A CDL is required to operate combination vehicles over 26,001 lbs GVWR.",
  },
  {
    id: "cv002",
    question: "Which CDL class is required to drive a combination vehicle with a GVWR over 26,001 lbs when the trailer GVWR exceeds 10,000 lbs?",
    options: ["Class C", "Class B", "Class A", "No CDL is required"],
    answer: 2,
    explanation: "Class A CDL is required for any combination vehicle with a GVWR over 26,001 lbs where the towed vehicle exceeds 10,000 lbs GVWR.",
  },
  {
    id: "cv003",
    question: "Combination vehicles are more dangerous than single vehicles primarily because:",
    options: [
      "They use air brakes",
      "They are longer and heavier, have more wheels to blow out, and are more prone to rollovers and jackknifing",
      "They have more blind spots on the left side only",
      "Their engines are less powerful",
    ],
    answer: 1,
    explanation: "Combination vehicles are longer, heavier, have more tires, and are subject to jackknife and rollover risks that single vehicles do not face.",
  },
  {
    id: "cv004",
    question: "What is 'crack-the-whip' effect in a combination vehicle?",
    options: [
      "The trailer swinging out when the tractor turns sharply",
      "The tendency of the rearmost trailer to swing violently when the tractor makes a sudden maneuver",
      "The vibration of the fifth wheel at highway speeds",
      "The trailer brakes locking before the tractor brakes",
    ],
    answer: 1,
    explanation: "In doubles and triples, the rear trailer can swing violently when the tractor makes sudden movements — this is the crack-the-whip effect. It can cause rollovers.",
  },
  // ── FIFTH WHEEL ────────────────────────────────────────────────────────────
  {
    id: "cv005",
    question: "The fifth wheel is located:",
    options: [
      "On the rear of the trailer",
      "On the frame of the tractor, near the rear axle, and accepts the trailer kingpin",
      "Between the trailer tandems",
      "On the converter dolly",
    ],
    answer: 1,
    explanation: "The fifth wheel is mounted on the tractor frame over or forward of the rear axle. The trailer kingpin locks into the fifth wheel to form the coupling.",
  },
  {
    id: "cv006",
    question: "What does 'sliding the fifth wheel' accomplish?",
    options: [
      "It changes the trailer's center of gravity",
      "It adjusts the weight distribution between the steer axle and drive axles, and changes the turning radius",
      "It releases the kingpin automatically",
      "It increases trailer clearance over the tractor cab",
    ],
    answer: 1,
    explanation: "Sliding the fifth wheel forward or backward shifts weight between axles. Moving it forward puts more weight on the steer axle; moving it rearward reduces steer axle weight.",
  },
  {
    id: "cv007",
    question: "Before coupling, the fifth wheel should be checked for:",
    options: [
      "Only that it is horizontal",
      "Proper lubrication, no cracks or damage, mounting bolts secure, and that the jaws are open and the plate is correctly tilted",
      "Only that the plate is clean",
      "Only that the release lever is accessible",
    ],
    answer: 1,
    explanation: "Inspect the fifth wheel for proper grease, cracks, missing or broken parts, secure mounting, open jaws, and correct tilt (front lower than rear) for coupling.",
  },
  {
    id: "cv008",
    question: "After coupling, how do you test that the kingpin is locked in the fifth wheel?",
    options: [
      "Visually confirm the jaws are around the kingpin from the driver's seat",
      "Slowly pull the tractor forward with the trailer parking brake on — the trailer should not move",
      "Apply the trailer service brakes only",
      "Check the air gauges",
    ],
    answer: 1,
    explanation: "The 'tug test' — with trailer wheel chocks or parking brakes set, pull the tractor forward gently. If the trailer moves, the coupling was not completed properly.",
  },
  {
    id: "cv009",
    question: "The kingpin should sit in the fifth wheel at which position?",
    options: [
      "At the front of the fifth wheel opening",
      "At the rear of the fifth wheel locking jaws — locked in",
      "Loosely in the center",
      "At any position as long as it doesn't fall out",
    ],
    answer: 1,
    explanation: "The kingpin must be fully seated at the rear of the fifth wheel with locking jaws closed around it. A loose or partially seated kingpin is extremely dangerous.",
  },
  {
    id: "cv010",
    question: "What is the danger of an 'uncoupled' or 'partially coupled' trailer?",
    options: [
      "The trailer brakes will not work",
      "The trailer may separate from the tractor while driving, causing a catastrophic accident",
      "The air lines will leak",
      "The landing gear will drag",
    ],
    answer: 1,
    explanation: "A trailer that separates from the tractor at speed can kill other road users. Always verify a secure connection before moving.",
  },
  // ── COUPLING PROCEDURE ─────────────────────────────────────────────────────
  {
    id: "cv011",
    question: "What is the correct height for the trailer during coupling?",
    options: [
      "The trailer should be higher than the tractor fifth wheel",
      "The trailer nose should be low enough that the fifth wheel will contact and raise it slightly when backed under",
      "The trailer should be at the same height as the tractor bed",
      "Height does not matter as long as the kingpin is aligned",
    ],
    answer: 1,
    explanation: "The trailer should be slightly lower than the unladen fifth wheel, so the fifth wheel contacts and lifts the front of the trailer slightly during coupling.",
  },
  {
    id: "cv012",
    question: "During coupling, the tractor should be backed under the trailer until:",
    options: [
      "The fifth wheel contacts the trailer apron plate",
      "You feel or hear the kingpin lock — then check the connection",
      "The tractor cab touches the nose of the trailer",
      "The trailer landing gear is fully raised",
    ],
    answer: 1,
    explanation: "Back under until the fifth wheel jaws lock around the kingpin. You should hear/feel a 'clunk' of engagement. Then verify by checking jaws and doing the tug test.",
  },
  {
    id: "cv013",
    question: "After successfully coupling a tractor to a trailer, what is the correct order for the next steps?",
    options: [
      "Connect electrical, raise landing gear, connect air lines, move",
      "Connect air lines, check brakes release, connect electrical, raise landing gear, do tug test, inspect coupling",
      "Raise landing gear, then connect everything else",
      "Only connect air lines and move",
    ],
    answer: 1,
    explanation: "Proper order: connect air lines → charge trailer air → verify trailer brakes release → connect electrical → supply air → raise landing gear → tug test → visually check coupling.",
  },
  {
    id: "cv014",
    question: "Landing gear should be raised:",
    options: [
      "Before connecting air lines",
      "After the coupling is verified and air lines are connected — raise fully before moving",
      "Only partway to allow for uncoupling",
      "After driving several feet to test the coupling",
    ],
    answer: 1,
    explanation: "Raise landing gear fully after completing the coupling check. Moving with landing gear partially down can cause it to hit the road surface.",
  },
  {
    id: "cv015",
    question: "When should you NEVER couple a trailer with its landing gear extended on uneven ground?",
    options: [
      "In rain",
      "When the trailer nose is so high that the fifth wheel would slide under the trailer body rather than coupling the kingpin",
      "In cold weather",
      "When the trailer is loaded",
    ],
    answer: 1,
    explanation: "If the trailer nose is too high, the fifth wheel may slide under the trailer body and ride up on it (called 'going under') rather than locking onto the kingpin — an extremely dangerous situation.",
  },
  // ── UNCOUPLING PROCEDURE ───────────────────────────────────────────────────
  {
    id: "cv016",
    question: "When uncoupling a trailer, the correct first steps are:",
    options: [
      "Pull the release handle and drive forward",
      "Park on level ground, apply trailer parking brakes, chock trailer wheels, lower landing gear to support the trailer",
      "Disconnect air lines first, then release the fifth wheel",
      "Release the fifth wheel, then disconnect air lines",
    ],
    answer: 1,
    explanation: "Safely uncoupling requires: park on level ground → apply trailer brakes → chock wheels → lower landing gear → disconnect air and electrical → release fifth wheel → slowly pull tractor forward.",
  },
  {
    id: "cv017",
    question: "After uncoupling, the trailer air lines (glad hands) should be:",
    options: [
      "Left connected to avoid contamination",
      "Disconnected and stored properly — hung on the dummy couplers on the tractor to prevent contamination and damage",
      "Tied together with the electrical cable",
      "Stored inside the cab",
    ],
    answer: 1,
    explanation: "Disconnect and hang glad hands on the tractor's dummy couplers. This prevents dirt from entering the lines and protects them from damage.",
  },
  {
    id: "cv018",
    question: "When is it unsafe to park an uncoupled trailer?",
    options: [
      "On dry pavement",
      "On soft ground where the landing gear could sink, causing the trailer to tip or fall",
      "In a truck terminal",
      "When fully loaded",
    ],
    answer: 1,
    explanation: "Landing gear can sink into soft ground, causing the trailer to lean or topple. Always park on firm, level surfaces and chock the wheels.",
  },
  // ── GLAD HANDS AND AIR LINES ───────────────────────────────────────────────
  {
    id: "cv019",
    question: "What are 'glad hands'?",
    options: [
      "Hand signals used by spotters",
      "The coupling devices that connect the tractor's air lines to the trailer's air lines",
      "The landing gear crank handles",
      "The trailer brake handle controls",
    ],
    answer: 1,
    explanation: "Glad hands are the couplings that connect the tractor service and emergency air lines to the trailer. They twist and lock together.",
  },
  {
    id: "cv020",
    question: "The emergency (supply) glad hand is usually marked with what color?",
    options: ["Blue", "Green", "Red", "Yellow"],
    answer: 2,
    explanation: "The emergency/supply glad hand is red. The service glad hand is blue. Cross-connecting them (red to blue) disables the trailer brakes — a dangerous mistake.",
  },
  {
    id: "cv021",
    question: "What happens if the glad hands are cross-connected (service line to emergency port)?",
    options: [
      "Nothing — both systems are interchangeable",
      "The trailer service brakes cannot be applied — the emergency brakes are disengaged but no service brakes work",
      "The tractor brakes will not work",
      "The compressor will overload",
    ],
    answer: 1,
    explanation: "Cross-connecting glad hands creates a situation where the trailer spring brakes are released (from the emergency line pressure) but service brakes cannot operate — the trailer has NO brakes.",
  },
  {
    id: "cv022",
    question: "If glad hand seals (O-rings) are missing or damaged, you should:",
    options: [
      "Connect them anyway and check for leaks while driving",
      "Replace the seals before connecting — damaged seals cause air leaks and brake problems",
      "Use tape to seal the connection",
      "Drive slowly to compensate",
    ],
    answer: 1,
    explanation: "Damaged O-ring seals cause air leaks at the glad hands. This can cause brake problems and may trigger tractor protection valve closure.",
  },
  // ── TRACTOR PROTECTION VALVE ───────────────────────────────────────────────
  {
    id: "cv023",
    question: "When does the tractor protection valve close automatically?",
    options: [
      "When the driver sets the parking brake",
      "When trailer air pressure drops below about 20–45 psi due to a major air leak on the trailer",
      "When the trailer is loaded over 40,000 lbs",
      "When air pressure exceeds 125 psi",
    ],
    answer: 1,
    explanation: "If the trailer develops a major air leak and pressure drops too far, the tractor protection valve closes to preserve air in the tractor so the driver can stop safely.",
  },
  {
    id: "cv024",
    question: "What is the purpose of the tractor protection valve?",
    options: [
      "To protect the tractor from fire",
      "To prevent the trailer's air leak from draining the tractor air supply and causing tractor brake failure",
      "To limit the maximum pressure in the tractor system",
      "To protect the fifth wheel from overload",
    ],
    answer: 1,
    explanation: "Without the tractor protection valve, a blown trailer air line would drain all tractor air, causing the tractor brakes to fail. The valve closes to preserve tractor air.",
  },
  // ── ANTI-JACKKNIFE ─────────────────────────────────────────────────────────
  {
    id: "cv025",
    question: "A tractor-trailer jackknife occurs when:",
    options: [
      "The trailer turns sharper than the tractor in a curve",
      "The tractor drive wheels lock up and the trailer pushes the tractor sideways, or the trailer wheels lock and the trailer swings out",
      "Both the tractor and trailer slide forward together",
      "The fifth wheel releases during braking",
    ],
    answer: 1,
    explanation: "Jackknife happens when wheels lock — drive axle jackknife (tractor swings) or trailer jackknife (trailer swings). Both cause loss of control.",
  },
  {
    id: "cv026",
    question: "The most common cause of jackknife is:",
    options: [
      "Excessive speed in curves",
      "Locking the wheels during hard braking, especially on slippery roads",
      "Improper coupling",
      "Overloading the trailer",
    ],
    answer: 1,
    explanation: "Locking wheels — especially drive axle wheels — is the most common jackknife trigger. ABS helps prevent this, but proper braking technique is still essential.",
  },
  {
    id: "cv027",
    question: "If a tractor-trailer begins to jackknife, the driver should:",
    options: [
      "Apply more brake pressure",
      "Release the brakes immediately and steer to regain control",
      "Apply only the trailer brakes",
      "Turn the wheel sharply in the opposite direction",
    ],
    answer: 1,
    explanation: "Immediately release the brakes to allow wheels to roll again — locked wheels cause jackknife. Then steer to recover. On ABS-equipped vehicles, the system does this automatically.",
  },
  {
    id: "cv028",
    question: "Rearward amplification means:",
    options: [
      "The sound from the trailer exhaust is louder than the tractor exhaust",
      "The rearmost unit in a combination vehicle sways more violently than the front unit during sudden maneuvers",
      "Braking force is amplified toward the rear of the combination",
      "The trailer tongue weight amplifies as speed increases",
    ],
    answer: 1,
    explanation: "In doubles and triples, the rear trailers amplify the sway of the front unit. A small steering correction at the front can cause a large sway in the rear — increasing rollover risk.",
  },
  // ── ROLLOVERS ──────────────────────────────────────────────────────────────
  {
    id: "cv029",
    question: "Combination vehicles have a higher rollover risk than single vehicles because:",
    options: [
      "They have more powerful engines",
      "Their high center of gravity and weight shift during turns makes them more susceptible to tipping",
      "Their wider wheelbase makes them less stable",
      "They have larger fuel tanks",
    ],
    answer: 1,
    explanation: "High center of gravity (especially loaded tankers or high-sided trailers) and the physics of weight transfer in turns make combination vehicles much more likely to roll over.",
  },
  {
    id: "cv030",
    question: "The best way to prevent rollover in a combination vehicle is to:",
    options: [
      "Use a lower gear in all curves",
      "Slow down — especially in curves, on ramps, and in high winds — and do not make abrupt steering inputs",
      "Brake hard just before the curve",
      "Keep the trailer loaded only in the rear",
    ],
    answer: 1,
    explanation: "Slowing well before curves and ramps, avoiding sudden steering, and maintaining proper load distribution are the key strategies to prevent rollover.",
  },
  {
    id: "cv031",
    question: "When a rollover begins, the driver should:",
    options: [
      "Brake hard and steer sharply to correct",
      "Hold the steering wheel firmly, steer into the roll if possible, and avoid abrupt corrections — the outcome is largely determined by speed entering the situation",
      "Apply only the trailer brakes",
      "Accelerate to outrun the rollover",
    ],
    answer: 1,
    explanation: "Once a rollover begins, there is little the driver can do. Prevention is the only real solution. If the vehicle is beginning to tip, braking hard often makes it worse.",
  },
  // ── BRAKING AND STOPPING ───────────────────────────────────────────────────
  {
    id: "cv032",
    question: "Why do combination vehicles have longer stopping distances than straight trucks?",
    options: [
      "They have weaker brakes",
      "They are heavier and the trailer brakes take longer to apply due to longer air lines",
      "Combination vehicles actually stop in shorter distances",
      "The fifth wheel absorbs braking force",
    ],
    answer: 1,
    explanation: "Greater weight and mass requires more force to stop, and longer air line distances increase brake lag to rear trailer brakes. Stopping distances for fully loaded combinations are significantly longer.",
  },
  {
    id: "cv033",
    question: "What is 'trailer swing' during braking?",
    options: [
      "The normal movement of the trailer on turns",
      "When the trailer wheels lock and the trailer slides sideways relative to the tractor",
      "When the trailer air brakes release too quickly",
      "When cargo shifts to the rear of the trailer",
    ],
    answer: 1,
    explanation: "Trailer swing occurs when trailer wheels lock during braking, causing the trailer to slide out sideways — which can lead to a jackknife or collision.",
  },
  {
    id: "cv034",
    question: "Empty combination vehicles can be more dangerous than loaded ones because:",
    options: [
      "Empty vehicles have more fuel to burn",
      "Empty trailers have less weight on the axles, making the tires more prone to locking up and skidding",
      "Empty vehicles accelerate too fast",
      "Empty trailers have higher air resistance",
    ],
    answer: 1,
    explanation: "Empty or lightly loaded trailers have less weight pressing the tires to the road, reducing traction. Trailer tires can lock very easily on an empty trailer.",
  },
  // ── CARGO AND WEIGHT DISTRIBUTION ─────────────────────────────────────────
  {
    id: "cv035",
    question: "Where should the heaviest freight be loaded in a trailer?",
    options: [
      "As far back (rear) as possible for traction",
      "As low as possible and centered front-to-back and side-to-side to keep the center of gravity low",
      "Against the front wall of the trailer for braking stability",
      "In the center side-to-side but high up for driver visibility",
    ],
    answer: 1,
    explanation: "Heavy freight loaded low and centered keeps the center of gravity low, improving stability and reducing rollover risk.",
  },
  {
    id: "cv036",
    question: "What is the maximum allowable gross vehicle weight (GVW) on interstate highways under federal bridge law?",
    options: [
      "60,000 lbs",
      "80,000 lbs",
      "90,000 lbs",
      "100,000 lbs",
    ],
    answer: 1,
    explanation: "Federal law limits gross vehicle weight to 80,000 lbs on interstate highways. Individual axle and tandem axle limits also apply and may be more restrictive.",
  },
  {
    id: "cv037",
    question: "What is the maximum weight on a single steering axle under federal law?",
    options: ["12,000 lbs", "20,000 lbs", "34,000 lbs", "40,000 lbs"],
    answer: 1,
    explanation: "Federal regulations limit single (steering) axles to 20,000 lbs. Tandem axles (axles spaced 40–96 inches apart) are limited to 34,000 lbs.",
  },
  {
    id: "cv038",
    question: "What is the maximum weight on a tandem axle group under federal law?",
    options: ["20,000 lbs", "25,000 lbs", "34,000 lbs", "40,000 lbs"],
    answer: 2,
    explanation: "A tandem axle group (two axles within 40–96 inches of each other) is limited to 34,000 lbs total under federal bridge law.",
  },
  // ── COMBINATION VEHICLE INSPECTION ─────────────────────────────────────────
  {
    id: "cv039",
    question: "During the coupling area inspection, you should check that:",
    options: [
      "Only the air lines are connected",
      "The fifth wheel is properly greased, the jaws are locked around the kingpin, and there is no gap between the apron plate and the fifth wheel",
      "Only the trailer clearance lights are on",
      "The landing gear is halfway down",
    ],
    answer: 1,
    explanation: "The coupling inspection must verify: fifth wheel lubricated, jaws locked, no gap between apron and fifth wheel, release arm secured, and air/electrical lines properly connected.",
  },
  {
    id: "cv040",
    question: "When inspecting the trailer during a pre-trip, you should check the trailer brake chambers for:",
    options: [
      "Only air pressure",
      "Proper mounting, no cracks or damage, and that pushrod stroke is within limits",
      "Only that they are painted correctly",
      "Only that the lines are connected",
    ],
    answer: 1,
    explanation: "Brake chambers must be properly mounted, free of cracks or damage, and pushrod stroke must not exceed the maximum limit for the chamber size.",
  },
  {
    id: "cv041",
    question: "The trailer kingpin should be inspected for:",
    options: [
      "Color and finish only",
      "Cracks, bending, or excessive wear that could cause the coupling to fail",
      "Only that it is the correct size",
      "Only that the fifth wheel will couple to it",
    ],
    answer: 1,
    explanation: "A damaged, cracked, or severely worn kingpin may fail under load, causing the trailer to separate from the tractor. Inspect visually for any damage.",
  },
  // ── TRAILER AIR BRAKES ─────────────────────────────────────────────────────
  {
    id: "cv042",
    question: "What is the purpose of the relay valve on a trailer?",
    options: [
      "To supply air to the tractor brakes",
      "To allow the trailer brakes to apply quickly by using local air from the trailer tanks rather than waiting for air to travel from the tractor",
      "To prevent trailer air pressure from exceeding 125 psi",
      "To automatically apply trailer brakes in an emergency",
    ],
    answer: 1,
    explanation: "Relay valves use a control signal from the service line while applying air from local trailer tanks to the brake chambers, reducing brake lag in long combinations.",
  },
  {
    id: "cv043",
    question: "After connecting air lines to a trailer, you should test the trailer brakes by:",
    options: [
      "Only checking the air gauges",
      "Using the trailer hand valve or pulling the trailer air supply (red) knob to apply trailer brakes and verify they hold",
      "Driving slowly and pressing the foot brake",
      "Only checking the trailer ABS light",
    ],
    answer: 1,
    explanation: "Test trailer brakes by applying them with the hand valve or emergency knob, then pull forward gently to confirm they hold. This verifies proper connection and function.",
  },
  // ── SLIDING TANDEM AXLES ────────────────────────────────────────────────────
  {
    id: "cv044",
    question: "What is the purpose of sliding trailer tandems?",
    options: [
      "To improve fuel economy",
      "To distribute the load weight between the trailer axles and the fifth wheel to comply with axle weight limits",
      "To improve turning radius only",
      "To lower the trailer height",
    ],
    answer: 1,
    explanation: "Sliding trailer tandems allows the driver to shift load weight between the rear trailer axles and the kingpin/fifth wheel to comply with state and federal axle weight limits.",
  },
  {
    id: "cv045",
    question: "Moving the trailer tandems forward (toward the nose of the trailer) will:",
    options: [
      "Put more weight on the trailer tandems and less on the tractor drive axles",
      "Put more weight on the tractor drive axles and less on the trailer tandems",
      "Have no effect on weight distribution",
      "Lower the trailer height",
    ],
    answer: 1,
    explanation: "Moving trailer tandems forward shifts load toward the front of the trailer, increasing drive axle weight on the tractor and reducing trailer tandem weight.",
  },
  // ── TURNING AND MANEUVERING ─────────────────────────────────────────────────
  {
    id: "cv046",
    question: "Why do combination vehicles require more turning space than single vehicles?",
    options: [
      "Because they are heavier",
      "Because the rear trailer wheels off-track (cut corners) significantly more than single vehicles",
      "Because they have wider steer axles",
      "Because their steering is hydraulically limited",
    ],
    answer: 1,
    explanation: "Long combination vehicles experience significant off-tracking — the rear wheels cut inside the front wheels' path. This requires extra turning space to prevent the trailer from mounting curbs.",
  },
  {
    id: "cv047",
    question: "When making a right turn in a tractor-trailer, you should:",
    options: [
      "Stay in the right lane and turn sharply",
      "Begin in the right lane, swing wider if needed, turn slowly, and watch the mirrors for the rear trailer wheels",
      "Move to the left lane first, then turn right",
      "Use the left lane to complete the turn",
    ],
    answer: 1,
    explanation: "Begin the turn from the correct position, move slowly, and monitor mirrors throughout. The rear trailer wheels will track inside the tractor's path — watch that they clear the curb.",
  },
  // ── BACKING ────────────────────────────────────────────────────────────────
  {
    id: "cv048",
    question: "When backing a combination vehicle, the trailer will go in the opposite direction from which you turn the steering wheel. This is because:",
    options: [
      "The trailer steering is reversed",
      "The pivot point at the fifth wheel causes the trailer to move opposite to the tractor's direction of backing",
      "The trailer has its own steering",
      "The fifth wheel is too tight",
    ],
    answer: 1,
    explanation: "When backing, turning the steering wheel left causes the trailer to go right. This is opposite to how the vehicle moves when going forward — it takes practice to master.",
  },
  {
    id: "cv049",
    question: "The best approach to backing a tractor-trailer is to:",
    options: [
      "Back as quickly as possible to minimize time in reverse",
      "Get Out And Look (GOAL) before backing, use a spotter, and back slowly",
      "Rely only on mirrors — avoid getting out of the cab",
      "Use camera systems and never get out",
    ],
    answer: 1,
    explanation: "GOAL (Get Out And Look) before backing to check the path. Use a spotter when possible. Back slowly — you have little room for error in a long combination vehicle.",
  },
  // ── CONVERTER DOLLY ────────────────────────────────────────────────────────
  {
    id: "cv050",
    question: "A converter dolly is used to:",
    options: [
      "Connect the tractor fifth wheel to the trailer kingpin",
      "Convert a single trailer into a double or triple combination by connecting one trailer to the rear of another",
      "Convert a loaded trailer to a lighter configuration",
      "Slide the trailer tandems automatically",
    ],
    answer: 1,
    explanation: "A converter dolly is a small axle-and-fifth-wheel assembly that couples to the rear of the lead trailer, allowing a second (pup) trailer to be towed behind.",
  },
  {
    id: "cv051",
    question: "During pre-trip inspection of a converter dolly, you should check:",
    options: [
      "Only the tires",
      "The air and electrical connections, the fifth wheel condition, the tow bar, safety chains, and that the brakes work",
      "Only that the dolly coupling is secure",
      "Only the wheel lug nuts",
    ],
    answer: 1,
    explanation: "Dolly inspection includes: tires, wheels, brakes, air and electrical connections, fifth wheel, pintle hook or ring connection, and safety chains.",
  },
  // ── PINTLE HOOK AND SAFETY CHAINS ─────────────────────────────────────────
  {
    id: "cv052",
    question: "Safety chains on a converter dolly are required to:",
    options: [
      "Prevent the dolly from bouncing",
      "Keep the dolly attached to the trailer if the main coupling fails — preventing the dolly from falling onto the road",
      "Provide extra braking force",
      "Prevent the dolly from overturning",
    ],
    answer: 1,
    explanation: "Safety chains prevent the converter dolly from falling onto the road and being run over by following vehicles if the primary coupling (pintle hook) fails.",
  },
  // ── COMBINATION VEHICLE EMERGENCIES ────────────────────────────────────────
  {
    id: "cv053",
    question: "If your trailer starts to skid (trailer swing), you should:",
    options: [
      "Apply the trailer brakes harder",
      "Release the brakes immediately, accelerate slightly if safe, and steer to bring the trailer back in line",
      "Apply only the tractor brakes",
      "Steer sharply to the skidding side",
    ],
    answer: 1,
    explanation: "Trailer skid/swing is usually caused by locked trailer wheels. Release the brakes to unlock them, then steer to correct. If on a straight road, you may need to accelerate slightly.",
  },
  {
    id: "cv054",
    question: "What should you do if your tractor-trailer starts to go into a jackknife?",
    options: [
      "Apply more brakes to stop faster",
      "Immediately release the brake and steer — but at high speeds, jackknife is usually unrecoverable",
      "Apply only the trailer hand valve",
      "Accelerate to pull the trailer straight",
    ],
    answer: 1,
    explanation: "Release the brakes immediately to unlock the drive wheels. At low speeds, steering may recover the jackknife. At highway speeds, it is usually unrecoverable — prevention is everything.",
  },
  // ── HIGH WIND AND ADVERSE CONDITIONS ──────────────────────────────────────
  {
    id: "cv055",
    question: "In high winds, combination vehicles are especially vulnerable to:",
    options: [
      "Tire blowouts",
      "Rollover, especially empty high-sided trailers or tankers, because wind force creates extreme side loading",
      "Engine overheating",
      "Fifth wheel failure",
    ],
    answer: 1,
    explanation: "High-sided trailers (van trailers, tankers) catch wind like a sail. Empty or partially loaded vehicles are most vulnerable because there is less weight to resist the overturning force.",
  },
  {
    id: "cv056",
    question: "When driving a combination vehicle in crosswinds, you should:",
    options: [
      "Speed up to reduce time in the wind",
      "Slow down, increase following distance, maintain firm steering control, and be prepared for sudden gusts when exiting protected areas",
      "Park on the side of the road",
      "Drive in the center of the road",
    ],
    answer: 1,
    explanation: "Reduce speed in crosswinds. Gusts can catch a trailer suddenly. Be especially careful exiting overpasses, gaps in tree lines, or other sheltered areas where wind conditions change abruptly.",
  },
  // ── LONG COMBINATION VEHICLES ──────────────────────────────────────────────
  {
    id: "cv057",
    question: "Which type of combination vehicle has the greatest off-tracking?",
    options: [
      "A 5-axle tractor-semitrailer",
      "A B-train (two full trailers with no converter dolly)",
      "A triple-trailer combination",
      "A tractor with a 28-foot pup trailer",
    ],
    answer: 2,
    explanation: "Triple-trailer combinations have the greatest off-tracking because the third trailer's axles must follow the path through three articulation points, causing significant corner-cutting.",
  },
  {
    id: "cv058",
    question: "What does 'nose of the trailer riding up on the fifth wheel' mean, and when is it dangerous?",
    options: [
      "Normal coupling procedure — always safe",
      "The trailer apron plate rests on the fifth wheel body rather than the kingpin locking — the coupling can fail without warning",
      "Only dangerous when the load is heavy",
      "Occurs only on older fifth wheel designs",
    ],
    answer: 1,
    explanation: "If the trailer is too high or the fifth wheel is too low, the tractor may slide under the trailer body without capturing the kingpin. This creates a false sense of coupling that will fail under load.",
  },
  {
    id: "cv059",
    question: "When parking a combination vehicle for extended periods, you should:",
    options: [
      "Only use the spring brakes",
      "Apply spring brakes, chock all trailer wheels, and lower the landing gear — do not rely solely on spring brakes",
      "Only chock the drive wheels of the tractor",
      "Leave it in gear without chocking",
    ],
    answer: 1,
    explanation: "Spring brakes can lose holding force over time due to slow air leaks. Wheel chocks and lowered landing gear provide backup protection, especially on grades.",
  },
  {
    id: "cv060",
    question: "The brake force in a combination vehicle should be balanced so that:",
    options: [
      "The tractor brakes much harder than the trailer",
      "The trailer brakes much harder than the tractor",
      "Both tractor and trailer braking force are balanced to prevent any individual axle from locking",
      "Only the front axle brakes are used for normal stops",
    ],
    answer: 2,
    explanation: "Balanced braking prevents any axle from locking. If the tractor brakes too hard, drive axle jackknife can occur. If trailer brakes too hard, trailer swing (jackknife) occurs.",
  },
];

export default combinationVehicles;
